import { HealthView } from './health';

export function HealthScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <HealthView />
    </div>
  );
}
